export default __webpack_public_path__ + "static/card-on-device-21c69d492662e868cf340a47c2863d4a.png";